import { ColorSwatch as AriaColorSwatch } from "react-aria-components";
import { css } from "@emotion/css";

export function ColorSwatch() {
  return <AriaColorSwatch className={styles.swatch} />;
}

const styles = {
  swatch: css({
    width: 20,
    height: 20,
    borderRadius: "var(--border-radius-2, 4px)",
    border: "1px solid var(--border-base)",
  }),
};
